import { VFrameSliderContext } from './context';

export const useVFrameSliderContext = VFrameSliderContext.hook;
